module.exports = __webpack_public_path__ + "img/title4.f028caf3.png";